import Vue from 'vue'
import Vuex from 'vuex'
import analyse from './modules/analyse'
import consultation from './modules/consultation'
import consultationDmp from './modules/consultation-dmp'
import consultationMotif from './modules/consultation-motif'
import cpn from './modules/cpn'
import examen from './modules/examen'
import formulaire from './modules/formulaire'
import medicament from './modules/medicament'
import patient from './modules/patient'


import createPersistedState from "vuex-persistedstate"
import auth from './modules/auth'
import soin from './modules/cat/soin'
import dossierMedical from './modules/dossier-medical'

// ===> MDT
import employe from "./modules/mdtravail/employe"
import societes from "./modules/mdtravail/societes"

import parametres from "./modules/parametres/parametres"
import tarifications from "./modules/tarifications/tarifications"

import consultationGroupSection from './modules/consultations/consultation-group-sections'
import historiqueConsultation from './modules/consultations/historique-consultation'
import protocoleSoins from './modules/consultations/protocole-soins'
import accessibilite from './modules/parametres/accessibilite'
import mixdata from './modules/parametres/mixdata'

import modelesAnalyses from "./modules/parametres/modeles-analyses"
import resultatsAnalyse from './modules/resultats-analyse'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        patient, analyse, consultation,
        formulaire, auth, examen,
        dossierMedical, soin, medicament,
        societes, employe, cpn,
        parametres, tarifications,
        consultationMotif, consultationDmp,
        mixdata, accessibilite, consultationGroupSection,
        protocoleSoins, historiqueConsultation,
        modelesAnalyses: modelesAnalyses,
        resultatsAnalyse,
    },
    plugins: [createPersistedState()]
})